<ui-section title="Are you sure?" type="sub-section">
	<section section-content>
		<p>
			You are about to disconnect from Sync by Closer. Are you sure you would
			like to continue?
		</p>
	</section>
</ui-section>

<footer class="flex justify-end items-center gap-2 mt-auto pt-4">
	<ui-button label="Cancel" (click)="close()" preset="MEDIUM_EMPHASIS" />
	<ui-button label="Confirm" (click)="confirm()" />
</footer>
